module.exports = __webpack_public_path__ + "static/media/hamburger-nav-icon-midnight.7ef955c7.svg";